export default __webpack_public_path__ + "locales/sk/Ldap.json?hash=9d1a171c6f15512cb0255caf8a32c603";